const frCH= {
    login: {
      title: 'Connexion',
      sign_in_btn: 'Connexion'
    },
    bar: {
        logout: 'Déconnexion',
        languages: 'Langues',
        settings: 'Ouvrir les paramètres'
    },
    language: {
      name: 'Français (Suisse)',
    },
    attributePage: {
        title: 'Modifications des attributs',
        viewChanges: 'Afficher les modifications',
        dateTime: 'Date',
        notificationType: 'Type de notification',
        notificationValue: 'Valeur de notification',
        oldValue: 'Ancienne valeur',
        newValue: 'Nouvelle valeur',
        accept: 'Accepter',
        reject: 'Rejeter',
    },
    Home: 'Accueil',
    load: 'En cours de chargement initial...',
    Requested: "Demandé",
    Viewed: "Vu",
    Executing: "En cours d’exécution",
    Completed: "Réalisé",
    Expired: "Expiré",
    Cancelled: "Annulé",
    Error: "Erreur",
    Rejected: "Rejeté",
    error: 'Un problème est survenu; veuillez réessayer plus tard.',
    displayname: 'Nom affiché',
    givenname: 'Nom',
    surname: 'Prénom',
    email: 'E-mail',
    mail: 'E-mail',
    name: 'Nom',
    firstname: 'Nom',
    lastname: 'Prénom',
    footer_copyright: 'Tous droits réservés.'
  };
  
  export default frCH;
  